import { StaticPageTemplate } from 'components/domain/staticPages/StaticPageTemplate'
import { getPublicStaticPage } from 'lib/api'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { NotFound } from './NotFound'

type LoadState = { status: 'loading' } | { status: 'loaded'; html: string } | { status: 'notFound' }

export const StaticPage = (): JSX.Element => {
  const { locale, rest } = useParams<{ locale: string; rest: string }>()
  const [state, setState] = useState<LoadState>({ status: 'loading' })

  useEffect(() => {
    let cancelled = false

    getPublicStaticPage(locale ?? '', rest ?? '')
      .then(({ html }) => {
        if (!cancelled) setState({ status: 'loaded', html })
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'notFound' })
      })

    return () => {
      cancelled = true
    }
  }, [locale, rest])

  if (state.status === 'loading') {
    return <div className="static-page__status">Loading…</div>
  }

  if (state.status === 'notFound') {
    return <NotFound />
  }

  return <StaticPageTemplate html={state.html} />
}
